interface AdyenProps {
  color?: string;
  className?: string;
  width?: number;
  height?: number;
}

export default function Adyen({
  width = 40,
  height = 15,
  color = '#0ABF53',
  className,
}: AdyenProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.2932 4.26318H2.38834V5.88159L5.58515 5.8816C5.68011 5.88161 5.77117 5.92069 5.83832 5.99027C5.90546 6.05984 5.94318 6.1542 5.94318 6.2526V9.11844H5.25997C5.16502 9.11844 5.07395 9.07935 5.00681 9.00978C4.93966 8.9402 4.90194 8.84584 4.90194 8.74745V6.69082H3.55193C3.21959 6.69082 2.90086 6.82763 2.66585 7.07114C2.43085 7.31465 2.29883 7.64492 2.29883 7.9893V9.43839C2.29883 9.78277 2.43085 10.113 2.66585 10.3566C2.90086 10.6001 3.21959 10.7369 3.55193 10.7369H8.5463V5.56166C8.5463 5.21728 8.41427 4.88701 8.17927 4.6435C7.94427 4.39999 7.62554 4.26318 7.2932 4.26318Z"
        fill={color}
      />
      <path
        d="M13.2317 9.11854H12.5485C12.4535 9.11854 12.3624 9.07945 12.2953 9.00988C12.2282 8.94031 12.1904 8.84594 12.1904 8.74755V4.26326H10.8405C10.5082 4.26326 10.1894 4.40007 9.95443 4.64358C9.71942 4.88709 9.5874 5.21736 9.5874 5.56174V9.43849C9.5874 9.78287 9.71942 10.1131 9.95443 10.3567C10.1894 10.6002 10.5082 10.737 10.8405 10.737H15.8349V1.56592H13.2318L13.2317 9.11854Z"
        fill={color}
      />
      <path
        d="M20.5208 9.11846H19.8376C19.7426 9.11846 19.6515 9.07937 19.5844 9.0098C19.5173 8.94022 19.4795 8.84586 19.4795 8.74747V4.26318H16.8765V9.43841C16.8765 9.78279 17.0085 10.1131 17.2435 10.3566C17.4785 10.6001 17.7972 10.7369 18.1296 10.7369H20.5208V11.5461H16.966V13.4339H21.8708C22.2032 13.4339 22.5219 13.2971 22.7569 13.0536C22.9919 12.8101 23.1239 12.4798 23.1239 12.1354V4.26318H20.5208V9.11846Z"
        fill={color}
      />
      <path
        d="M29.1594 4.26318H24.165V9.43839C24.165 9.78277 24.2971 10.113 24.5321 10.3566C24.7671 10.6001 25.0858 10.7369 25.4181 10.7369H30.323V9.11844H27.1262C27.0312 9.11844 26.9402 9.07935 26.873 9.00978C26.8059 8.9402 26.7682 8.84584 26.7682 8.74745V5.88163H27.4514C27.5463 5.88163 27.6374 5.92072 27.7045 5.99029C27.7717 6.05987 27.8094 6.15423 27.8094 6.25262V8.30923H29.1594C29.4917 8.30923 29.8105 8.17242 30.0455 7.92891C30.2805 7.6854 30.4125 7.35513 30.4125 7.01075V5.56166C30.4125 5.39114 30.3801 5.22229 30.3171 5.06475C30.2541 4.90721 30.1618 4.76407 30.0455 4.6435C29.9291 4.52292 29.791 4.42728 29.6389 4.36202C29.4869 4.29677 29.324 4.26318 29.1594 4.26318Z"
        fill={color}
      />
      <path
        d="M36.448 4.26318H31.4536V10.7369H34.0567V5.88159H34.7399C34.8348 5.88187 34.9257 5.92105 34.9928 5.99057C35.0599 6.06008 35.0977 6.15427 35.098 6.25258V10.7369H37.7011V5.56166C37.7011 5.21728 37.5691 4.88701 37.334 4.6435C37.099 4.39999 36.7803 4.26318 36.448 4.26318Z"
        fill={color}
      />
    </svg>
  );
}
